import { DialogState } from "../stores/models/DialogState";

export function getInitialDialogStates<DialogType extends string>(dialogTypes: DialogType[]) {
    let state = {} as { [key in DialogType]: DialogState };
    dialogTypes.forEach(dialog => { state[dialog as DialogType] = new DialogState(); });
    return state;
}